<ng-container thr-parent-form>
    <div class="row">
        <div class="col-12 col-sm-4 col-md-2">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <mat-select
                    [name]="prefix + 'StreetType'"
                    [placeholder]="'form.street-type' | translate"
                    required
                    [disabled]="isDisabled"
                    [(ngModel)]="address.streetType"
                    (blur)="onChange()"
                    #streetTypeCtrl="ngModel"
                >
                    <mat-option *ngFor="let streetType of streetTypes" [value]="streetType.id.value">
                        {{ streetType.name }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="streetTypeCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-8 col-md-10">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <input
                    [name]="prefix + 'Street'"
                    matInput
                    [placeholder]="'form.street' | translate"
                    required
                    maxlength="40"
                    [disabled]="isDisabled"
                    [(ngModel)]="address.street"
                    (blur)="onChange()"
                    #streetCtrl="ngModel"
                />
                <mat-error *ngIf="streetCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-3 col-md-2">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <input
                    [name]="prefix + 'Number'"
                    matInput
                    [placeholder]="'form.number' | translate"
                    required
                    maxlength="5"
                    [disabled]="isDisabled"
                    [(ngModel)]="address.number"
                    (blur)="onChange()"
                    #numberCtrl="ngModel"
                />
                <mat-error *ngIf="numberCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-3 col-md-2">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <input
                    [name]="prefix + 'Floor'"
                    matInput
                    [placeholder]="'form.floor' | translate"
                    maxlength="3"
                    [disabled]="isDisabled"
                    [(ngModel)]="address.floor"
                    (blur)="onChange()"
                    #floorCtrl="ngModel"
                />
                <mat-error *ngIf="floorCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-3 col-md-2">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <input
                    [name]="prefix + 'Door'"
                    matInput
                    [placeholder]="'form.door' | translate"
                    maxlength="3"
                    [disabled]="isDisabled"
                    [(ngModel)]="address.door"
                    (blur)="onChange()"
                    #doorCtrl="ngModel"
                />
                <mat-error *ngIf="doorCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-3 col-md-2">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <input
                    [name]="prefix + 'Stair'"
                    matInput
                    [placeholder]="'form.stair' | translate"
                    maxlength="3"
                    [disabled]="isDisabled"
                    [(ngModel)]="address.stair"
                    (blur)="onChange()"
                    #stairCtrl="ngModel"
                />
                <mat-error *ngIf="stairCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-6 col-md-4">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <input
                    [name]="prefix + 'PostalCode'"
                    matInput
                    [placeholder]="'form.postal-code' | translate"
                    required
                    maxlength="7"
                    [min]="0"
                    [disabled]="isDisabled"
                    [(ngModel)]="address.postalCode"
                    (blur)="onChange()"
                    #postalCodeCtrl="ngModel"
                />
                <mat-error *ngIf="postalCodeCtrl.hasError('min') && !postalCodeCtrl.hasError('required')">
                    {{ 'form.validation.invalid.number' | translate }}
                </mat-error>
                <mat-error *ngIf="postalCodeCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-6 col-md-4">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <mat-select
                    [name]="prefix + 'Country'"
                    [placeholder]="'form.country' | translate"
                    required
                    [disabled]="isDisabled"
                    [(ngModel)]="address.country"
                    (ngModelChange)="onCountryChange()"
                    (blur)="onChange()"
                    #countryCtrl="ngModel"
                >
                    <mat-option *ngFor="let country of countries" [value]="country.id.value">
                        {{ country.name }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="countryCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-6 col-md-4">
            <mat-form-field class="full-width mb-3 mb-sm-4" *ngIf="cities && cities.length > 0">
                <mat-select
                    [name]="prefix + 'Province'"
                    [placeholder]="'form.province' | translate"
                    required
                    [disabled]="isDisabled"
                    [(ngModel)]="address.state"
                    (blur)="onChange()"
                    #provinceCtrl="ngModel"
                >
                    <mat-option *ngFor="let city of cities" [value]="city.id.value">
                        {{ city.name }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="provinceCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width mb-3 mb-sm-4" *ngIf="!cities || cities.length === 0">
                <input
                    [name]="prefix + 'Province'"
                    matInput
                    [placeholder]="'form.province' | translate"
                    required
                    [disabled]="isDisabled"
                    [(ngModel)]="address.state"
                    (blur)="onChange()"
                    #provinceCtrl="ngModel"
                />
                <mat-error *ngIf="provinceCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-6 col-md-4">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <input
                    [name]="prefix + 'Locality'"
                    matInput
                    [placeholder]="'form.locality' | translate"
                    required
                    [disabled]="isDisabled"
                    [(ngModel)]="address.city"
                    (blur)="onChange()"
                    #localityCtrl="ngModel"
                />
                <mat-error *ngIf="localityCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
    </div>
</ng-container>
